document.addEventListener('alpine:init', () => {
  Alpine.data('MixMatchBundle', () => ({
    section_id: '',
    product_form_id: '',
    cache: {
      $variants: null
    },
    mm_products: [],
    mm_discount_percent: 0,
    selected_options: [],
    flags: {
      bundle_empty: false
    },
    init() {
      this.cache.$section = this.$el;
      this.section_id = this.$el.dataset.section_id;
      this.product_form_id = this.$el.dataset.product_form_id;
      this.cache.$variants = document.querySelector(`variant-radios[data-section="${this.section_id}"]`);
      this.InitWatchers();

      this.selected_options = [...this.cache.$variants.querySelectorAll('input:checked')].map(item => item.value);
      // _utils.LogJSON(this.selected_options);

      window.mm_products = this.mm_products = JSON.parse(this.$el.dataset.mm_products);
      this.mm_discount_percent = parseInt(this.$el.dataset.mm_discount_percent);
    },
    InitWatchers() {
      this.$watch('selected_options', () => {
        this.mm_products.forEach(product => {
          let selected_variant = product.variants.find(v => v.options.join('/') === this.selected_options.join('/'));
          product.selected_variant = selected_variant;
        });
        window.mm_products = this.mm_products;
        // _utils.LogJSON(this.mm_products);
      });

      this.cache.$variants.addEventListener('change', (e) => {
        this.selected_options = [...this.cache.$variants.querySelectorAll('input:checked')].map(item => item.value);
      });

      document.addEventListener('mm-update-variant', (e) => {
        let product = this.mm_products.find(p => p.handle === e.detail.product_handle);
        let selected_variant = product.variants.find(v => v.options.join('/') === e.detail.selected_options.join('/'));
        product.selected_variant = {...selected_variant};
      });
    },
    ResizeImageUrl(url, size) {
      if (!url) return '';
      return _utils.ResizeImageUrl(url, size);
    },
    FormatMoney(value) {
      return formatMoney(value);
    },
    GetSelectedVariants() {
      let selected_variants = this.mm_products.map(p => p.selected_variant);
      selected_variants = selected_variants.filter(v => v !== undefined);
      return selected_variants;
    },
    GetBundlePrices() {
      let variants_price = this.GetSelectedVariants().reduce((sum, v) => sum + v.price, 0);
      return {
        total_price: variants_price,
        bundle_price: variants_price * (1 - (this.mm_discount_percent / 100))
      }
    },
    // async e_AddBundleToCart() {
    //   if($('.pre-order_wrapper_bundle').hasClass('active')){
    //     console.log('true')
    //   }
    //   let cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    //   let isPreOrder = $('.pre-order_wrapper_bundle').hasClass('active');
    //   let items = this.GetSelectedVariants().map(v => {
    //     return {
    //       id: v.id,
    //       quantity: 1,
    //       properties: {
    //         '_bundly__bundle_id': `gid://shopify/Product/${this.cache.$section.dataset.mm_bundly_product}`,
    //         '_bundly__component_id': `gid://shopify/Collection/${this.cache.$section.dataset.mm_bundly_collection}`,
    //         '_bundly__timestamp': new Date().getTime()
    //       }
    //       if (isPreOrder) {
    //         properties['Pre0Order'] = true;
    //       }
    //     }
    //   });
    //   // _utils.LogJSON(items);

    //   let formData = { items }; 
    //   formData.sections = cart.getSectionsToRender().map((section) => section.id);
    //   let res = await fetch(window.Shopify.routes.root + 'cart/add.js', {
    //     method: 'POST',
    //     headers: {
    //       'Content-Type': 'application/json'
    //     },
    //     body: JSON.stringify(formData)
    //   });
    //   // console.log(res);
    //   if (res.ok) {
    //     if (typeof monster_refresh === 'function') monster_refresh();

    //     let res_json = await res.json();
    //     cart.renderContents(res_json);
    //   }
    //   else {
    //     await res.json().then(console.error);
    //   }
    // },
    async e_AddBundleToCart() {
      // if ($('.pre-order_wrapper_bundle').hasClass('active')) {
      //   console.log('true');
      // }
    
      let cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      // let isPreOrder = $('.pre-order_wrapper_bundle').hasClass('active');
      
    
      let items = this.GetSelectedVariants().map(v => {
        let PreOrderConfirmationId = $(`#var_${v.id}`).attr('_data-id');
        let PreOrderConfirmationAvailable = $(`#var_${v.id}`).attr('_data-available') === "true";;
        let PreOrderConfirmationInventory = parseInt($(`#var_${v.id}`).attr('_data-inventory'));
        let properties = {
          '_bundly__bundle_id': `gid://shopify/Product/${this.cache.$section.dataset.mm_bundly_product}`,
          '_bundly__component_id': `gid://shopify/Collection/${this.cache.$section.dataset.mm_bundly_collection}`,
          '_bundly__timestamp': new Date().getTime()
        };

        // console.log(`PreOrderConfirmation: ${PreOrderConfirmation} and var_${v.id}`);
        if (PreOrderConfirmationAvailable && PreOrderConfirmationInventory <= 0){
          properties['Pre-Order'] = 'True';
        }
        // if (isPreOrder) {
        //   properties['Pre-Order'] = 'True';
        // }
        console.log(v)
    
        return {
          id: v.id,
          quantity: 1,
          properties: properties
        };
      });
    
      // _utils.LogJSON(items);
    
      let formData = { items };
      formData.sections = cart.getSectionsToRender().map((section) => section.id);
      console.log(`FormData: ${JSON.stringify(formData)}`);
    
      // let res = await fetch(window.Shopify.routes.root + 'cart/add.js', {
      //   method: 'POST',
      //   headers: {
      //     'Content-Type': 'application/json'
      //   },
      //   body: JSON.stringify(formData)
      // });
    
      // if (res.ok) {
      //   if (typeof monster_refresh === 'function') monster_refresh();
    
      //   let res_json = await res.json();
      //   cart.renderContents(res_json);
      // } else {
      //   await res.json().then(console.error);
      // }
    },
    e_EditBundleItem(product_handle) {
      let product = this.mm_products.find(p => p.handle === product_handle);
      document.dispatchEvent(new CustomEvent('mm-switch-product', {
        detail: { 
          product_handle: product_handle,
          selected_options: product.selected_variant.options
        }
      }));
    }
  }));

  Alpine.data('MixMatchModal', () => ({
    current_product: '',
    init() {
      this.InitWatchers();
    },
    InitWatchers() {
      document.addEventListener('mm-switch-product', (e) => {
        let $modal_opener = document.querySelector('[data-modal="#PopupModal__BundleItem"] button');
        this.current_product = e.detail.product_handle;
        $modal_opener.dispatchEvent(new Event('click'));
      });

      document.addEventListener('mm-close-modal', (e) => {
        let $modal = this.$el.closest('.mm-bundle-modal');
        if (!$modal) return;
        $modal.removeAttribute('open');
        document.body.classList.remove('overflow-hidden');
      });
    }
  }));

  Alpine.data('ProductModal', () => ({
    product: null,
    variant: null,
    init() {
      this.InitWatchers();
      document.addEventListener('DOMContentLoaded', this.LoadProduct.bind(this));
    },
    InitWatchers() {
      document.addEventListener('mm-switch-product', (e) => {
        this.$el.querySelectorAll('variant-radios').forEach($variant_radios => {
          e.detail.selected_options.forEach(option => {
            let $input = $variant_radios.querySelector(`input[value="${option}"]`);
            $input.checked = true;
            $input.dispatchEvent(new Event('change'));
            // $input.dispatchEvent(new Event('change', { bubbles: true }));
          });
        });
        this.variant = {...this.product.variants.find(v => v.options.join('/') === e.detail.selected_options.join('/'))};
      });      
    },
    async LoadProduct() {
      let product_handle = this.$el.dataset.product_handle;
      this.product = window.mm_products.find(p => p.handle === product_handle);
      this.variant = this.product.selected_variant;
      let res = await fetch(`/products/${product_handle}`).then(res => res.text());
      let $product = new DOMParser().parseFromString(res, 'text/html');

      $product.querySelectorAll('variant-radios').forEach($variant_radios => {
        $variant_radios.setAttribute('data-update-url', 'false');
        $variant_radios.setAttribute('x-on:change', 'e_UpdateVariant');
      });

      $product.querySelectorAll('variant-radios input').forEach($input => {
        $input.setAttribute('name', `${product_handle}-${$input.getAttribute('name')}`);
      });

      $product.querySelector('.product__media-wrapper').innerHTML = `
        <template x-if="variant">
          <div class="product__media">
            <img :src="ResizeImageUrl(variant.featured_image?.src, '600x')" />
          </div>
        </template>
      `;

      let $product_form = $product.querySelector('.product-form');
      $product_form.insertAdjacentHTML('afterend', `
          <button class="product-form__submit button button--primary focus-inset bundle_popup_btn"
            :disabled="!variant.available"
            @click="e_UpdateMixMatchVariant">
            <template x-if="variant.available">
              <span>ADD TO BUNDLE</span>
            </template>
            <template x-if="!variant.available">
              <span>SOLD OUT</span>
            </template>
            <div class="loading-overlay__spinner hidden">
              <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg>
            </div>
          </button>
      `);
      $product_form.remove();
      this.$el.insertAdjacentElement('beforeend', $product.querySelector('[id*="MainProduct-template"]'));
      this.InitWatchers();
    },
    e_UpdateVariant(e) {
      let $product = this.$el.closest('product-modal-item');
      let selected_options = [...$product.querySelectorAll('variant-radios input:checked')].map(item => item.value);
      this.variant = {...this.product.variants.find(v => v.options.join('/') === selected_options.join('/'))};
    },
    e_UpdateMixMatchVariant(e) {
      let $product = this.$el.closest('product-modal-item');
      let selected_options = [...$product.querySelectorAll('variant-radios input:checked')].map(item => item.value);
      this.product.selected_variant = {...this.product.variants.find(v => v.options.join('/') === selected_options.join('/'))};
      document.dispatchEvent(new CustomEvent('mm-update-variant', {
        detail: {
          product_handle: $product.dataset.product_handle,
          selected_options
        }
      }));
      document.dispatchEvent(new CustomEvent('mm-close-modal'));
    },
    ResizeImageUrl(url, size) {
      if (!url) return '';
      return _utils.ResizeImageUrl(url, size);
    },
    FormatMoney(value) {
      return formatMoney(value);
    }
  }));
});